import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

export type Club = {
    id: number;
    shortName: string;
    longName: string;
    clubTypeId: number;
    description?: string | null;
};
export type ClubCollection = {
    typeName: string;
    id: number;
    clubs: Club[];
};

export type ClubCollections = ClubCollection[];

export const fetchGolfClubs = withLogs(async (supabase: SupabaseClient<Database>): Promise<ClubCollections> => {
    const { data, error } = await supabase.from('club_types').select('type_name,id, clubs(*)');

    if (error) {
        throw error;
    }

    return camelcaseKeys(data, { deep: true });
}, 'fetchGolfClubs');

export const fetchAllClubs = withLogs(async (supabase: SupabaseClient<Database>): Promise<Club[]> => {
    const { data, error } = await supabase.from('clubs').select('*');

    if (error) {
        throw error;
    }

    return camelcaseKeys(data, { deep: true });
}, 'fetchAllClubs');
